import { render, staticRenderFns } from "./HrIcon.vue?vue&type=template&id=50bfccf6"
import script from "./HrIcon.vue?vue&type=script&lang=js"
export * from "./HrIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports